import { useEffect, useState } from "react";
import { Plus } from "lucide-react";
import { useI18n } from "@/context/I18nContext";
import { stickerUrl } from "@/components/editor/stickers/fx";
import { Chips } from "@/components/editor/stickers/StickerOptions";

export const CustomSticker = ({ styles, onAdd }) => {
  const { t } = useI18n();
  const [text, setText] = useState("");
  const [style, setStyle] = useState("chrome");
  const [preview, setPreview] = useState({ text: "GG", style: "chrome" });
  useEffect(() => {
    const h = setTimeout(() => setPreview({ text: (text.trim() || "GG").toUpperCase(), style }), 450);
    return () => clearTimeout(h);
  }, [text, style]);
  const add = () => onAdd({ id: "custom", text: (text.trim() || "GG").toUpperCase().slice(0, 24), style });
  return (
    <div className="space-y-3" data-testid="custom-sticker">
      <div className="flex gap-2">
        <input value={text} onChange={(e) => setText(e.target.value.slice(0, 24))} placeholder={t("st.custom_ph")} data-testid="custom-sticker-input"
          className="flex-1 min-w-0 rounded-lg bg-[#070912] border border-white/10 px-3 py-2 text-sm text-white uppercase font-display tracking-wide placeholder:normal-case placeholder:text-slate-600 focus:outline-none focus:border-[#2f7bff]/70" />
        <button type="button" onClick={add} data-testid="custom-sticker-add-btn" className="cx-btn rounded-lg px-3 text-xs font-semibold flex items-center gap-1"><Plus className="w-3.5 h-3.5" />{t("st.add")}</button>
      </div>
      <Chips testid="custom-sticker-style" items={styles} value={style} onChange={setStyle} label={(k) => t(`st.style_${k}`)} />
      <div className="rounded-xl border border-white/5 bg-[repeating-conic-gradient(#0d1020_0_25%,#0a0c18_0_50%)] bg-[length:22px_22px] grid place-items-center h-28 p-3">
        <img src={stickerUrl({ id: "custom", ...preview })} alt="" className="max-h-full max-w-full object-contain cx-pop" key={`${preview.text}-${preview.style}`} data-testid="custom-sticker-preview" />
      </div>
    </div>
  );
};
